import OfferLineItem from "./OfferLineItem";
import OfferDetails from "./OfferDetails";
import InsuranceInfo from "./InsuranceInfo";
import ContactInfo from "./ContactInfo";
import InvoiceInfo from "./InvoiceInfo";

export default class Offer {
  offerDetails: OfferDetails = new OfferDetails();
  lineItems: Array<OfferLineItem> = new Array<OfferLineItem>();
  insuranceInfo: InsuranceInfo = new InsuranceInfo();
  contactInfo: ContactInfo = new ContactInfo();
  invoiceInfo: InvoiceInfo = new InvoiceInfo();
  comment: string = "";

  public constructor(init?: Partial<Offer>) {
    this.offerDetails = new OfferDetails(init?.offerDetails);
    init?.lineItems?.forEach(lineItem => {
      this.lineItems.push(new OfferLineItem(lineItem));
    });
    this.contactInfo = new ContactInfo(init?.contactInfo);
    this.insuranceInfo = new InsuranceInfo(init?.insuranceInfo);
    this.invoiceInfo = new InvoiceInfo(init?.invoiceInfo);
  }

  public getMockData() {
    this.offerDetails = new OfferDetails({
      name: "Usługa transportowa na budowie DK22 Czarlin-Knybawa",
      number: "ZAK/2020/00001",
      deliveryAddress: "Budowa DK 22 Czarlin-Knybawa",
      deliveryPeriodStart: "2020-06-01T0:00:00.0000000Z",
      deliveryPeriodEnd: "2020-08-15T0:00:00.0000000Z",
      expires: "2020-05-10T0:00:00.0000000Z",
      contactPerson: "jan.kowalski@gmail.com",
      terms: "DDP"
    });
    this.lineItems.push(
      new OfferLineItem({
        index: "test-001",
        description: "praca godzinowa samochodu ciężarowego",
        unit: "szt",
        amount: 1200,
        indexName: "test-001 name",
        lineId: "0001"
      })
    );
    this.lineItems.push(
      new OfferLineItem({
        index: "test-002",
        description: "usługa transportowa na odcinku 9km",
        unit: "szt",
        amount: 1200,
        indexName: "test-002 name",
        lineId: "0002"
      })
    );
    this.lineItems.push(
      new OfferLineItem({
        index: "test-003",
        description: "usługa transportowa na odcinku 10km",
        unit: "szt",
        amount: 700,
        indexName: "test-003 name",
        lineId: "0003"
      })
    );
    this.lineItems.push(
      new OfferLineItem({
        index: "test-004",
        description: "usługa transportowa na odcinku 11-13km",
        unit: "szt",
        amount: 700,
        indexName: "test-004 name",
        lineId: "0004"
      })
    );
    this.contactInfo.person = "Fabian Kowalski";
    this.contactInfo.email = "Fabian.kowalski@gmail.com";
    this.contactInfo.address = "ul. Ogrodowa 2, 00-001 Warszawa";
    this.contactInfo.phoneNumber = "333-444-555";
  }
}
